import axios from "axios";

const BASE_ROUTE_DOTNET_SERVER = process.env.REACT_APP_BASE_ROUTE_DOTNET_SERVER || "http://localhost:5097/api/";

const api = axios.create({
  baseURL: BASE_ROUTE_DOTNET_SERVER,
});

// Interceptor para adicionar o token de autorização em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken-house");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para lidar com o refresh do token
api.interceptors.response.use(
  (response) => response, // Se a resposta for bem-sucedida, apenas a retorna
  async (error) => {
    const originalRequest = error.config;
    // Se o erro for 401 e não for uma tentativa de refresh
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem("refreshToken-house");
        const response = await axios.post(BASE_ROUTE_DOTNET_SERVER + "auth/refresh-token", {
          refreshToken,
        });
        const { access_token, refresh_token } = response.data;

        localStorage.setItem("accessToken-house", access_token);
        localStorage.setItem("refreshToken-house", refresh_token);

        api.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
        originalRequest.headers["Authorization"] = `Bearer ${access_token}`;

        return api(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem("accessToken-house");
        localStorage.removeItem("refreshToken-house");
        localStorage.removeItem("user");
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;